const LoadingAnimation: React.FC<{
	fullScreen?: boolean,
	width?: number,
	height?: number
}> = ({ fullScreen = true, width = 400, height = 400 }) => {
	return <div style={{
		position: fullScreen ? 'fixed' : 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		backgroundColor: fullScreen ? 'rgba(0, 0, 0, 0.5)' : '',
		zIndex: 1000,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	}}>
		<div style={{
			width: Math.min(width, 80),
			height: Math.min(height, 80),
			border: '4px solid #e5e7eb',
			borderTop: '4px solid #6366f1',
			borderRadius: '50%',
			animation: 'spin 1s linear infinite',
		}} />
		<style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
	</div>
}

export default LoadingAnimation;
